import React, {Component} from 'react'
import './Layout/ProgressBar.css'

class ProgressBar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isVisible: false,
      value: 0,
      handler: null,
      increase: 2,
      type: props.type
    }
    this.progress = this.progress.bind(this)
  }

  progress () {
    const {value, increase, handler} = this.state
    if (!this.props.isLoading) { return undefined }
    if (value < 30) {
      this.setState({value: value + increase})
    } else if (value < 60) {
      this.setState({value: value + (increase / 2)})
    } else if (value < 80) {
      this.setState({value: value + (increase / 4)})
    } else if (value < 100) {
      this.setState({value: value + (increase / 8)})
    } else {
      clearInterval(handler)
      setTimeout(() => {
        this.setState({value: 100})
        this.setState({isVisible: false})
      }, 800)
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({type: nextProps.type})
    if (nextProps.isLoading) {
      this.setState({handler: setInterval(this.progress, 100), isVisible: true})
    }
  }

  componentWillUpdate (nextProps) {
    // loading is finished
    if (nextProps.isLoading === !this.props.isLoading && nextProps.isLoading === false) {
      this.setState({increase: 30})
    }
  }

  componentWillUnmount () {
    clearInterval(this.state.handler)
  }

  render () {
    const {value, isVisible, type} = this.state
    if (!isVisible) return null
    return (
      <div className={`progress-bar progress-${type}`} style={{width: `${value}%`}} />
    )
  }
}

ProgressBar.propTypes = {
  isLoading: React.PropTypes.bool,
  type: React.PropTypes.string
}

export default ProgressBar



// WEBPACK FOOTER //
// ./src/components/Common/ProgressBar/ProgressBar.js